import turf from 'src/utils/turf'

export const METERS_IN_A_MILE = 1609.34

export const milesToMeters = (miles: number): number => {
  return miles * METERS_IN_A_MILE
}

export const metersToMiles = (meters: number): number => {
  return meters / METERS_IN_A_MILE
}

export const sqKmToMiles = (sqKm: number): number => {
  return turf.convertArea(sqKm, 'kilometers', 'miles')
}

export const sqMToMiles = (sqM: number): number => {
  return turf.convertArea(sqM, 'meters', 'miles')
}

export const acresToSqft = (acres: number): number => {
  return acres * 43560
}

export const milesToFeet = (miles: number): number => {
  return miles * 5280
}
